<template>
  <div class="scroll-section">
    <div class="fact-counters">
      <div v-for="(number, name, idx) in numbers" :key="idx" class="fact-counter animate">
        <span class="number">{{ number.value }}{{ (name === 'sms_count') ? '+' : '' }}</span>
        <span class="desc" :class="name">{{ $t('facts.facts[' + idx + ']') }}</span>
        <span v-if="name === 'sms_count'">... and counting</span>
      </div>
    </div>
    <div class="facts-bg" :style="'background-image: url(' + facts_bg_img + ');'"></div>
  </div>
</template>

<script>

import factsBg from '../.././assets/facts-bg-optimized.png'
import { mapGetters, mapActions } from 'vuex'
import { isElementVisible } from '../../useElementVisible.js'

export default {
  name: 'Facts',
  data() {

    let numbers = {
      year: {
        value: (new Date()).getFullYear(),
        end: 1999,
      },
      sms_count: {
        value: 0.1,
        end: 2.5
      },
      countries: {
        value: 42,
        end: 180,
      }
    }


    if (window.ieLegacy()) {
      numbers.year.value = numbers.year.end
      numbers.sms_count.value = numbers.sms_count.end
      numbers.countries.value = numbers.countries.end
    }

    return {
      exclude_from_nav: true,
      nav_title: 'facts',
      active: true,
      facts_bg_img: factsBg,
      numbers: numbers,

    }
  },
  mounted() {
    this.hideElements()

    isElementVisible(this.$el, () => {
      this.runSectionAnimations()
    }).attachDefaultEvents()

  },
  watch: {
    active_section_name(val) {
      if (val === this.$options._componentTag) {
        if (!this.is_animating_scroll) {
          this.runSectionAnimations()
        }
      }
    },
    scroll_pos(val) {
      if (this.scroll_pos > (this.$el.offsetTop - 400) && this.scroll_pos < ((this.elHeight - 100) + this.$el.offsetTop)) {
        if (!this.is_animating_scroll) {
          this.runSectionAnimations()
          this.setActiveSection(this.$options._componentTag)
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      scroll_pos: 'getScrollPos',
      active_section_name: 'getActiveSectionName',
      is_animating_scroll: 'getAnimatingScrollState'
    }),
    elHeight() {
      return Math.ceil(this.$el.getBoundingClientRect().height)
    }
  },
  methods: {
    ...mapActions([
      'setActiveSection'
    ]),
    animateNumber(idx) {
      let _this = this
      switch (idx) {
        case 0:
          // year
          TweenMax.to(this.numbers.year, 0.7, {
            value: _this.numbers.year.end,
            ease: Power0.easeNone,
            onUpdate() {
              _this.numbers.year.value = Math.ceil(_this.numbers.year.value)
            }
          })
          break
        case 1:
          // sms
          TweenMax.to(this.numbers.sms_count, 0.7, {
            value: _this.numbers.sms_count.end,
            ease: Power0.easeNone,
            onUpdate() {
              _this.numbers.sms_count.value = Math.ceil(_this.numbers.sms_count.value * 10) / 10
            }
          })
          break
        case 2:
          // countries
          TweenMax.to(this.numbers.countries, 0.7, {
            value: _this.numbers.countries.end,
            ease: Power0.easeNone,
            onUpdate() {
              _this.numbers.countries.value = Math.ceil(_this.numbers.countries.value)
            }
          })
          break
      }
    },
    runSectionAnimations() {

      if (window.ieLegacy()) {
        return
      }

      if (this.animationsDone || this.animationsInit) return
      let _this = this
      let _counter = 0

      let els = this.$el.querySelectorAll('.animate')
      TweenMax.staggerFromTo(els, 0.7, {
        autoAlpha: 0,
        x: -30
      }, {
        autoAlpha: 1,
        x: 0,
        ease: Power1.easeInOut,
        onComplete() {
          _this.animateNumber(_counter)
          _counter++
        }
      }, 1.3)
      this.animationsInit = true
    },
    // rounding millions on sms count, thousands on events
    rounded(num, amount) {
      return Math.round(num / amount) * amount
    },
    hideElements() {

      if (window.ieLegacy()) {
        return
      }

      let elements = this.$el.querySelectorAll('.animate')
      TweenMax.set(elements, {
        autoAlpha: 0
      })
    },
    formatNumber(num) {
      if (num > 1000000) {
        return this.rounded(num, 100000000) / 1000000 + '+'
      } else if (num > 2000) {
        return this.rounded(num, 1000) + '+'
      } else {
        return num
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.scroll-section {
  position: relative;
  background-color: #5c6884;
  padding-top: 100px;
  padding-bottom: 100px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  overflow: hidden;

  @media screen and (max-width: 768px) {
    padding-bottom: 30px;
  }
}
</style>

<style lang="scss">
.fact-counters {
  position: relative;
  z-index: 2;
  width: 100%;
  max-width: 1264px;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: flex-start;

  @media screen and (max-width: 1024px) {
    padding: 0 3rem;
  }

  @media screen and (max-width: 768px) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}

.fact-counter {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  text-align: center;

  @media screen and (max-width: 900px) {
    width: 100%;
    margin-bottom: 2rem;

    &:nth-child(2) {
      margin-bottom: 4rem;
    }
  }

  &:nth-child(1) {
    width: 25%;
  }

  &:nth-child(2) {
    width: 25%;
  }

  &:nth-child(3) {
    width: 25%;
  }

  &:nth-child(4) {
    width: 25%;
  }

  @media screen and (max-width: 480px) {
    width: 100% !important;
  }

  >.number {
    color: white;
    font-weight: 900;
    font-size: 5.6rem;
    line-height: 1;
    margin-bottom: 1rem;

    @media screen and (max-width: 1290px) {
      font-size: 4.4rem;
    }

    @media screen and (max-width: 1024px) {
      font-size: 3.4rem;
      margin-bottom: .1rem;
    }
  }

  >.desc {
    text-transform: uppercase;
    color: #d5e2ff;
    font-size: 1.2rem;
    font-weight: 500;

    @media screen and (max-width: 900px) {
      text-align: center;
    }

    +span {
      display: block;
      position: absolute;
      right: 1rem;
      top: 100%;
      margin-top: -1.4rem;
      color: #ff7c4e;
      font-family: 'angelique_roseregular';
      font-size: 3rem;

      @media screen and (max-width: 900px) {
        font-size: 2.5rem;
        white-space: pre;
      }
    }
  }
}

.facts-bg {
  position: absolute;
  z-index: 1;
  right: 0;
  top: -20px;
  background-size: contain;
  width: 550px;
  padding-bottom: 50%;
  background-repeat: no-repeat;

  @media screen and (max-width: 1024px) {
    width: 350px;
  }

  @media screen and (max-width: 768px) {
    width: 240px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sections/Facts.vue